import { useAppMutation } from "../../../http/useAppMutation.ts";
import { notifier } from "../../../utils/notifier.tsx";
import { useWorkspace } from "../../hooks/useWorkspace.ts";

export const useTrainModel = ({
  modelUuid,
  onTrainModelSuccess,
}: {
  modelUuid: string;
  onTrainModelSuccess?: () => void;
}) => {
  const { workspace } = useWorkspace();

  const trainMutation = useAppMutation({
    path: "references/train",
    invalidate: [
      `workspaces/${workspace.uuid}/references`,
      `references/${modelUuid}`,
    ],
    onSuccess: () => {
      notifier.success("Training launched successfully!");
      onTrainModelSuccess?.();
    },
  }).mutation;

  return {
    mutate: () => {
      trainMutation.mutate({
        uuid: modelUuid,
        workspace_uuid: workspace.uuid,
      });
    },
    isLoading: trainMutation.isLoading,
  };
};
